import { Resource } from '@/infrastructure/resource/resource';
import { RuleActivateNewUser } from '../../commands/Concrete/RuleActivateNewUser';
import {
    StateRule,
    StateTransitionOptions,
    StateResult,
    StateNavigationAction,
    Transition,
    addNavigationElement,
    addEmptyNavigationElement,
    addPreviousNext,
    addPrevious,
  } from "../StateInterfaces";
  
  import { BaseState }  from "../StateMachine";
  import { StateHome } from "./StateHome";
  import { StateLogin } from "./StateLogin";
  import { NavigatonIcons } from "@/business/application/NavConst";
  import {Commands} from "@/business/application/commands/Command";
  
  
  export class StateKnownRegistration extends BaseState {
    private static mainState = "PrivacyPolicy";
    private static transitions: Transition[] = []; 
    private isForwardClicked = true
    private static callerState : StateResult = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''}
  
    public constructor() {
      super()    
     
    }
  
    public getStartTransition(condition: string) : StateResult {
      StateKnownRegistration.transitions = []
      this.getTransitions()
      this.setCallerState(condition)    
      return this.getTransition(this.getTransitions()[0]);
    }
  
    private setCallerState(callerState: string) : StateResult {
      if (callerState === "Login" || callerState === "Home") {      
        StateKnownRegistration.callerState.newMainState = "Verification"
        StateKnownRegistration.callerState.newState = "WaitOfUserActivation"
        StateKnownRegistration.callerState.routeName = callerState
        StateKnownRegistration.callerState.oldMainState = callerState
        StateKnownRegistration.callerState.oldState = callerState
      }    
      return StateKnownRegistration.callerState;
    }
  
    private callerState() : StateResult {
      return StateKnownRegistration.callerState
    }
  
    public next(rule: StateRule, options: StateTransitionOptions): StateResult {
      return this.calculateState(
        rule,
        options,
        false,
        StateKnownRegistration.mainState
      );
    }
  
    public previous(rule: StateRule,options: StateTransitionOptions): StateResult {
      return this.calculateState(rule,options,true,StateKnownRegistration.mainState);
    }
  
    protected checkState(transition: Transition,options: StateTransitionOptions): StateResult {
      const context = this.getContext()
      let newResultState = this.getTransition(transition);
     
  
      let newState: any
      if (!options.lookahead && transition.newState != "") {
        switch (newResultState.newMainState) {
          case "Login":
            newState = new StateLogin();
            newResultState = newState.getStartTransition("Login")
            this.getContext().transitionTo(newState,newResultState)                  
            break;
          case "Home":
            newState = new StateHome();
            newResultState = newState.getStartTransition("Home")
            this.getContext().transitionTo(newState,newResultState)                  
            break;        
          default:
            context.transitionTo(
              new StateKnownRegistration(),
              newResultState
            );
        }
      }
      return newResultState;
    }
  
    protected calculateState( rule: StateRule,options: StateTransitionOptions,isPrevious: boolean, _mainState: string): StateResult {    
      const context = this.getContext()
      const currentState = context.getCurrentState()
      this.isForwardClicked = ! isPrevious
      const transition = this.getTransitions().filter(row => {
        if (row.nav === StateNavigationAction.Next && this.isForwardClicked) {        
          
          if(currentState.newState == "ShowKnownInformation" &&  row.oldState == "KnownRegistration") {
            if (  row.condition == "isFinish" ) return true;    
          }
        } 
        
        if (row.nav === StateNavigationAction.Previous && !this.isForwardClicked) {              
          if(currentState.newState == "ShowKnownInformation" &&  row.oldState == "KnownRegistration") {
            if (  row.condition == "isFinish" ) return true;    
          }
  
        }
  
      });            
      return this.checkState(transition[0], options);
    }
  
    protected calculateBusinessConditions(rule: StateRule, _resultState: StateResult): string {
      if (
        rule.conditions === undefined ||
        rule.conditions === null ||
        rule.conditions.length <= 0
      ) {
        return "";
      }
  
      if (rule.conditions.length == 1) {
        if ( rule.conditions[0].value === undefined ) {
          return ""
        }
  
        return rule.conditions[0].value;
      }
      return "";
    }
  
    public getTransitions(): Transition[] {
      if (StateKnownRegistration.transitions.length === 0) {
  
        //*****************************************
        //--> Wizzard Start
        //*****************************************        
        let t: Transition = { mainState: "Login", newMainState: "KnownRegistration", nav: StateNavigationAction.Next, oldState: "Login", newState: "ShowKnownInformation", condition: "isStart"};      
        t = addPrevious(t, Commands.PreviousPage);
        StateKnownRegistration.transitions.push(t);
  
        //*****************************************
        //--> Wizzard vorward
        //*****************************************
        t = {mainState: "KnownRegistration",newMainState: "Login", oldState: "KnownRegistration", newState: "Login",condition: "isFinish", nav: StateNavigationAction.Next}
        t = addPrevious(t,Commands.PreviousPage);
        StateKnownRegistration.transitions.push(t);
  
        //*****************************************
        //--> Wizzard backward
        //*****************************************
        t = {mainState: "KnownRegistration",newMainState: "Login", oldState: "KnownRegistration", newState: "Login" ,condition: "isFinish", nav: StateNavigationAction.Previous}
  
        t = addEmptyNavigationElement(t,1);
        t = addEmptyNavigationElement(t,2);
        t = addNavigationElement(t,3,{command: Commands.Jump, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
        t = addNavigationElement(t,4,{command: Commands.Jump, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Settings",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Settings });
        StateKnownRegistration.transitions.push(t);
      
      }
      return StateKnownRegistration.transitions;
    }
  }
  